const KST = 'Asia/Seoul'

const parts = (value, options) => Object.fromEntries(new Intl.DateTimeFormat('en-US', { timeZone: KST, ...options }).formatToParts(new Date(value)).map(({ type, value: part }) => [type, part]))

export function formatFreshness(iso, { stale = false, staleAfterMs = null, now = Date.now() } = {}) {
  const timestamp = Date.parse(iso || '')
  if (!Number.isFinite(timestamp)) return null
  const currentStale = stale || (staleAfterMs != null && now - timestamp >= staleAfterMs)
  const date = parts(timestamp, { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false })
  const today = parts(now, { year: 'numeric', month: 'numeric', day: 'numeric' })
  const sameDay = date.year === today.year && date.month === today.month && date.day === today.day
  const clock = `${date.hour}:${date.minute}`
  const label = sameDay ? clock : `${Number(date.month)}/${Number(date.day)} ${clock}`
  return { label, stale: currentStale }
}

export function freshnessText(iso, options = {}) {
  const value = formatFreshness(iso, options)
  if (!value) return null
  return `마지막 갱신 ${value.label}${value.stale ? ' · 오래된 데이터' : ''}`
}

export const ANALYTICS_STALE_AFTER = 5 * 60 * 1000
export const REALTIME_STALE_AFTER = 45 * 1000
export const GROWTH_STALE_AFTER = 6 * 60 * 60 * 1000
